import { doc, getDoc, getDocs, setDoc, deleteDoc, collection, query, where } from "firebase/firestore";
import { db } from "../firebase";

// Find registered client UID by email from "client" collection
const findClientUidByEmail = async (email) => {
  if (!email) return null;
  try {
    const clientQuery = query(
      collection(db, "client"),
      where("email", "==", email)
    );
    const snapshot = await getDocs(clientQuery);
    if (!snapshot.empty) {
      return snapshot.docs[0].id;
    }
  } catch (error) {
    console.error("Error finding client by email:", error);
  }
  return null;
};

// Get client UID from a contact ID (looks up contact email, then finds registered client)
const getClientUidFromContactId = async (contactId) => {
  if (!contactId) return null;
  try {
    const contactDoc = await getDoc(doc(db, "clients", contactId));
    if (!contactDoc.exists()) return null;

    const contactEmail = contactDoc.data().email;
    if (!contactEmail) return null;

    return await findClientUidByEmail(contactEmail);
  } catch (error) {
    console.error("Error getting client UID from contact:", error);
    return null;
  }
};

// Sync invoice data to client's sharedInvoices collection
export const syncInvoiceToClient = async (contactId, invoiceData, invoiceId, lawyerUid, lawyerName) => {
  if (!contactId) return;
  try {
    const clientUid = await getClientUidFromContactId(contactId);
    if (!clientUid) return;

    const sharedInvoiceRef = doc(db, "client", clientUid, "sharedInvoices", invoiceId);
    await setDoc(sharedInvoiceRef, {
      ...invoiceData,
      sharedBy: lawyerUid,
      sharedByName: lawyerName,
      sharedAt: new Date().toISOString(),
      originalInvoiceId: invoiceId,
    });
    console.log("Invoice synced to client:", clientUid);
  } catch (error) {
    console.error("Error syncing invoice to client:", error);
  }
};

// Re-sync: Read the full invoice from lawyer's collection and sync to client
export const reSyncInvoiceToClient = async (lawyerUid, invoiceId, contactId, lawyerName) => {
  if (!contactId || !lawyerUid || !invoiceId) return;
  try {
    const invoiceRef = doc(db, "lawyers", lawyerUid, "invoices", invoiceId);
    const invoiceSnap = await getDoc(invoiceRef);
    if (!invoiceSnap.exists()) return;

    const invoiceData = invoiceSnap.data();
    await syncInvoiceToClient(contactId, invoiceData, invoiceId, lawyerUid, lawyerName);
  } catch (error) {
    console.error("Error re-syncing invoice to client:", error);
  }
};

// Delete synced invoice from client's sharedInvoices
export const deleteSyncedInvoice = async (contactId, invoiceId) => {
  if (!contactId) return;
  try {
    const clientUid = await getClientUidFromContactId(contactId);
    if (!clientUid) return;

    await deleteDoc(doc(db, "client", clientUid, "sharedInvoices", invoiceId));
    console.log("Synced invoice deleted from client:", clientUid);
  } catch (error) {
    console.error("Error deleting synced invoice:", error);
  }
};
